import { atom } from 'jotai/vanilla';
import type { ZoomTransform } from 'd3';
import { zoomIdentity } from 'd3-zoom';

const InitialTransform = zoomIdentity.scale(0.1);
export const contentTransformAtom = atom<ZoomTransform>(InitialTransform);
